import request from '@/request/index.js'

/**
 *  登录请求
 *    入参:
 *      auth_code 平台返回的code
 *      dna	string dna信息
 *      nick_name	string 昵称
 *      avatar_url	string 头像链接
 *    出参: 与下方userInfo接口类似
 *
 */
export function login(data) {
  return request({
    url: '/login/user',
    method: 'POST',
    data
  })
}

/**
 *  生成用户DNA
 *    入参:
 *      random_id	string 客户端产生的随机数
 *    出参:
 *      Dna	string 加密后的dna
 */
export function hello(data) {
  return request({
    url: '/login/hello',
    method: 'POST',
    data
  })
}

/**
 *  获取用户信息
 *    入参: 无
 *    出参:
 *      id	number 用户编号
        token	string 用户token
        nickname	string 昵称
        headImg	string 头像地址
        origin_device_id	string
        mobile	string 手机号
        login_status	number 登陆状态（1：已登陆）
        ali_name	string
        ali_account	string
        last_login	string 最后一次登陆时间
        open_id	string 用户的openid
        created_at	number 创建时间
        updated_at	number
        all_coin	number 当前金币数
        vip	boolean	是否vip
 */
export function userInfo(data) {
  return request({
    url: '/user/info',
    method: 'POST',
    data
  })
}
